const WORKSPACE_ANALYTICS_PATH = /^\/workspace\/[^/]+\/analytics\/?$/;
const WORKSPACE_REQUEST_LOGS_TABLE_PATH = /^\/workspace\/[^/]+\/request-logs\/?$/;
const WORKSPACE_PROMPT_VERSION_PATH = /^\/workspace\/[^/]+\/prompt\/[^/]+\/version\/[^/]+\/?$/;
const WORKSPACE_WORKFLOW_VERSION_PATH = /^\/workspace\/[^/]+\/workflow\/[^/]+\/version\/[^/]+\/?$/;
const WORKSPACE_REQUEST_DETAIL_PATH = /^\/workspace\/[^/]+\/request\/[^/]+/;
const WORKSPACE_TRACES_SEARCH_PATH = /^\/workspace\/[^/]+\/traces-search\/?$/;
const WORKSPACE_TRACES_ANALYTICS_PATH = /^\/workspace\/[^/]+\/traces-analytics\/?$/;

export const isWorkspaceAnalyticsPathname = (pathname: string): boolean =>
  WORKSPACE_ANALYTICS_PATH.test(pathname);

export const isWorkspaceRequestLogsTablePathname = (pathname: string): boolean =>
  WORKSPACE_REQUEST_LOGS_TABLE_PATH.test(pathname);

export const isWorkspacePromptVersionPathname = (pathname: string): boolean =>
  WORKSPACE_PROMPT_VERSION_PATH.test(pathname);

export const isWorkspaceWorkflowVersionPathname = (pathname: string): boolean =>
  WORKSPACE_WORKFLOW_VERSION_PATH.test(pathname);

export const isWorkspaceRequestDetailPathname = (pathname: string): boolean =>
  WORKSPACE_REQUEST_DETAIL_PATH.test(pathname) && !pathname.includes("/playground");

export const shouldPersistStructuredSearchReturnTo = (pathname: string): boolean =>
  isWorkspaceRequestLogsTablePathname(pathname) || isWorkspacePromptVersionPathname(pathname);

export const isWorkspaceTracesSearchPathname = (pathname: string): boolean =>
  WORKSPACE_TRACES_SEARCH_PATH.test(pathname);

export const isWorkspaceTracesAnalyticsPathname = (pathname: string): boolean =>
  WORKSPACE_TRACES_ANALYTICS_PATH.test(pathname);
